import {
  setAbookid,
  getAbookid,
  settoll,
  gettoll,
  getAbookName,
  setAbookName
} from "utils/storage";
const author = {
  state: {
    bookid: getAbookid(),
    bookName: getAbookName(),
    isMoney: gettoll(),
    isChange: true
  },
  mutations: {
    SET_BOOKID: (state, id) => {
      state.bookid = id;
      setAbookid(id);
    },
    SET_BOOKName: (state, name) => {
      state.bookName = name;
      setAbookName(name);
    },
    SET_TOll: (state, toll) => {
      state.isMoney = toll;
      settoll(toll);
    },
    SET_ISCHANGE: (state, change) => {
      state.isChange = change;
    }
  },
  actions: {
    //   登录
    setAInfo({ commit }, objs) {
      commit("SET_BOOKID", objs.bookid);
      commit("SET_TOll", objs.allowPrice);
      commit("SET_BOOKName", objs.name);
    },
    // 是否提示切换
    setIschange({ commit }, value) {
      commit("SET_ISCHANGE", value);
    }
  }
};
export default author;
